import MobileApi from 'lib/MobileApi';
import { useEffect, useRef } from 'react';
// eslint-disable-next-line import/no-unresolved
import { useVideoController } from '@nbcnews/omega-player/context/videoController';
// eslint-disable-next-line import/no-unresolved
import { useVideoTime } from '@nbcnews/omega-player/context/state/time';


/**
 * Hook to set up a communication channel for chromeless video players.
 * @param {object} props - The properties for the hook.
 * @param {boolean} props.autoplayEnabled - Flag indicating if autoplay is enabled for the video.
 * @param {(shouldMount: boolean) => void} props.onMountRequest - Callback function to be called when the video is mounted.
 * @param {(shouldAutoplay: boolean) => void} props.onAutoplayRequest - Callback function to be called when autoplay is requested.
 * @param {(shouldMutedAutoplay: boolean) => void} props.onMutedAutoplayRequest - Callback function to be called when muted autoplay is requested.
 */
export function useChromelessCommunicationChannel({
  autoplayEnabled = false,
  onMountRequest,
  onAutoplayRequest,
  onMutedAutoplayRequest,
}) {
  const { play, pause, setMute } = useVideoController();
  const { seekToLiveEdge } = useVideoTime();
  const wasPausedThroughNativeBridgeRef = useRef(false);

  useEffect(() => {
    MobileApi.getVideoStatus(({ pipActive }) => {
      if (pipActive) {
        pause();
      }
    });

    MobileApi.playbackAction((playbackAction) => {
      if (playbackAction === 'play') {
        if (autoplayEnabled || wasPausedThroughNativeBridgeRef.current) {
          play();
        }
      } else if (playbackAction === 'pause') {
        wasPausedThroughNativeBridgeRef.current = true;
        pause();
      } else if (playbackAction === 'mute') {
        setMute(true);
        onMutedAutoplayRequest(true);
      } else if (playbackAction === 'unmute') {
        setMute(false);
        onMutedAutoplayRequest(false);
      } else if (playbackAction === 'seekToLiveEdge') {
        seekToLiveEdge();
      } else if (playbackAction === 'mount') {
        onMountRequest(true);
      } else if (playbackAction === 'unmount') {
        onMountRequest(false);
      } else if (playbackAction === 'autoplay') {
        onAutoplayRequest(true);
      } else if (playbackAction === 'clickToPlay') {
        onAutoplayRequest(false);
      }
    });
  }, []);
}
